/**
 * Set the attributes for the Background Panel
 * @type {Object}
 */
const defaultBackground = {
	backgroundType: 'color',
	backgroundColor: '#eeeeee',
	backgroundOverlayImage: '',
	backgroundOverlayVideo: '',
	backgroundOverlayOpacity: 50,
	backgroundGradient: {},
	backgroundImage: {},
	backgroundPosition: 'center center',
	backgroundRepeat: 'no-repeat',
	backgroundImageSize: 'cover',
	backgroundVideoSize: 'cover',
	customBackgroundColor: '',
	hasParallax: false,
	backgroundFocalPoint: {
		x: 0.5,
		y: 0.5,
	},
	backgroundVideoFocalPoint: {
		x: 0.5,
		y: 0.5,
	},
	backgroundVideo: {},
	backgroundVideoMuted: true,
	backgroundVideoLoop: true,
	backgroundVideoAutoplay: true,
	openPopover: true,
};

const emptyBackground = {
	backgroundType: 'none',
	backgroundOverlayImage: '',
	backgroundOverlayVideo: '',
	backgroundOverlayOpacity: 50,
	backgroundGradient: {},
	backgroundImage: {},
	backgroundPosition: 'center center',
	backgroundRepeat: 'no-repeat',
	backgroundImageSize: 'cover',
	backgroundVideoSize: 'cover',
	customBackgroundColor: '',
	hasParallax: false,
	backgroundFocalPoint: {
		x: 0.5,
		y: 0.5,
	},
	backgroundVideoFocalPoint: {
		x: 0.5,
		y: 0.5,
	},
	backgroundVideo: {},
	backgroundVideoMuted: true,
	backgroundVideoLoop: true,
	backgroundVideoAutoplay: true,
	openPopover: true,
};

const BackgroundAttributes = {
	backgroundType: {
		type: 'string',
		default: 'image',
	},
	backgroundColor: {
		type: 'string',
	},
	backgroundOverlay: {
		type: 'number',
		default: 0,
	},
	backgroundGradient: { type: 'object',
		default: {
			colorFirst: 'rgba(0,0,0,0)',
			locFirst: 0,
			colorSecond: 'rgba(0,0,0,0)',
			locSecond: 100,
			angle: 180,
			gType: 'linear',
		},
	},
	backgroundOverlayOpacity: {
		type: 'number',
		default: 50,
	},
	backgroundGradientBehavior: {
		type: 'string',
	},
	backgroundImage: {
		type: 'object',
		default: {
			id: null,
			alt: null,
			url: null,
		},
	},
	backgroundPosition: {
		type: 'string',
		default: 'center center',
	},
	backgroundRepeat: {
		type: 'string',
		default: 'no-repeat',
	},
	backgroundImageSize: {
		type: 'string',
		default: 'cover',
	},
	backgroundVideoSize: {
		type: 'string',
		default: 'cover',
	},
	customBackgroundColor: {
		type: 'string',
	},
	hasParallax: {
		type: 'boolean',
		default: false,
	},
	backgroundFocalPoint: {
		type: 'object',
		default: {
			x: 0.5,
			y: 0.5,
		},
	},
	backgroundVideoFocalPoint: {
		type: 'object',
		default: {
			x: 0.5,
			y: 0.5,
		},
	},
	backgroundVideo: {
		type: 'object',
		default: {},
	},
	videoMuted: {
		type: 'boolean',
		default: true,
	},
	videoLoop: {
		type: 'boolean',
		default: true,
	},
	openPopover: {
		type: 'boolean',
		default: false,
	},
};

export {
	BackgroundAttributes,
	defaultBackground,
	emptyBackground,
};
